import { WORK_ORDER_CHECK_OUTCOMES } from '../../utils/InvoiceUtils';

/**
 * How firmly we put the question, by how firmly the backend answered it.
 *
 * There is deliberately no "Confidence: Low" label any more. A confidence figure shown beside a
 * list of differences reads as confidence in the differences, when what it actually measures is
 * whether the invoice belongs to this work order at all — and that measure is already the reason
 * the dialog is on screen. So it drives the wording, the colour and the button instead of being
 * printed as a number nobody can situate.
 *
 * It follows that a clean match shows nothing: if we are confident the invoice belongs here, any
 * remaining textual difference is not worth interrupting anyone for.
 */
export const WORK_ORDER_CHECK_SEVERITY = {
	[WORK_ORDER_CHECK_OUTCOMES.MISMATCH]: {
		title: (document: string) => `${document} appears to belong to a different work order`,
		subtitle: 'Please verify you selected the correct file before proceeding',
		continueLabel: 'PROCEED ANYWAY',
		iconClassName: 'bg-character-danger',
		invoiceCellClassName: 'bg-character-dangerBg',
	},
	[WORK_ORDER_CHECK_OUTCOMES.REVIEW]: {
		title: (document: string) =>
			`Some ${document.toLowerCase()} details differ from this work order`,
		subtitle:
			'Review the highlighted fields below. You can continue if these discrepancies are expected',
		continueLabel: 'CONTINUE',
		iconClassName: 'bg-sunsetOrange-8',
		invoiceCellClassName: 'bg-calendulaGold-1',
	},
};

/** The uploaded document's name in the copy: the same check runs on invoices and quotes. */
export type WorkOrderCheckDocumentLabel = 'Invoice' | 'Quote';

export const getWorkOrderCheckSeverity = (
	outcome: string,
	documentLabel: WorkOrderCheckDocumentLabel = 'Invoice'
) => {
	const severity =
		WORK_ORDER_CHECK_SEVERITY[outcome] ||
		WORK_ORDER_CHECK_SEVERITY[WORK_ORDER_CHECK_OUTCOMES.MISMATCH];
	return { ...severity, title: severity.title(documentLabel) };
};
